// qq咨询
/* eslint-disable */
export default {
  install(Vue) {
    Vue.prototype.qqConsult = function () {
      var aLink = document.createElement('a')
      var evt = document.createEvent('MouseEvents')
      evt.initEvent('click', true, true)
      aLink.target = '_blank'
      aLink.href = 'http://wpa.qq.com/msgrd?v=3&uin=3095636883&site=qq&menu=yes'
      aLink.dispatchEvent(evt)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/qqConsult.js